'use client'

import { cn } from '@/utils/styles/cn'
import { useVisualViewportBottomOffset } from '@/utils/hooks/use-visual-viewport-bottom-offset'

type IFixedBottomCtaBarProps = {
    children: React.ReactNode
    className?: string
    topMarginClassName?: string
}

/**
 * On mobile: fixed to the bottom of the viewport; uses Visual Viewport API so the bar
 * stays above the on-screen keyboard when it opens. On desktop: in-flow.
 */
export function FixedBottomCtaBar({ children, className, topMarginClassName = 'mt-3' }: IFixedBottomCtaBarProps) {
    const keyboardBottomOffset = useVisualViewportBottomOffset()

    return (
        <div
            className={cn(
                'w-full flex flex-col-reverse md:flex-row gap-2 items-stretch md:items-center justify-between',
                topMarginClassName,
                'max-md:fixed max-md:left-0 max-md:right-0 max-md:z-10',
                'max-md:bg-white max-md:border-t max-md:border-black/5',
                'max-md:p-4 max-md:pb-[max(0.75rem,env(safe-area-inset-bottom))]',
                className
            )}
            style={{ bottom: keyboardBottomOffset }}
        >
            {children}
        </div>
    )
}
